import React from 'react';
import { Phone } from 'lucide-react';
import { PHONES, CONTACT } from '../content';
import LiveBadge from './LiveBadge';
import { onCallClick, onWhatsappClick } from '../lib/trackHelpers';

const WA_ICON = (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
    <path d="M5.077 18.828l.532-1.869A8.85 8.85 0 0 1 3.2 12C3.2 7.134 7.134 3.2 12 3.2c4.866 0 8.8 3.934 8.8 8.8 0 4.866-3.934 8.8-8.8 8.8a8.845 8.845 0 0 1-4.893-1.471l-2.03.499zM12 1C6.477 1 2 5.477 2 11c0 1.821.439 3.538 1.215 5.057L2 22l6.071-1.59A10.976 10.976 0 0 0 12 21c5.523 0 10-4.477 10-10S17.523 1 12 1z"/>
  </svg>
);

export default function FinalCTA({ headline, sub }) {
  return (
    <section
      data-testid="final-cta"
      style={{
        background: 'linear-gradient(135deg, rgba(229,51,51,.08) 0%, rgba(5,5,13,1) 100%)',
        borderTop: '1px solid var(--border)',
        borderBottom: '1px solid var(--border)',
        padding: '4.5rem 0',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Radial glow */}
      <div style={{
        position: 'absolute', top: '50%', left: '50%',
        transform: 'translate(-50%,-50%)',
        width: 700, height: 500,
        background: 'radial-gradient(ellipse, rgba(229,51,51,.1) 0%, transparent 65%)',
        pointerEvents: 'none',
      }} />

      <div className="wrap" style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
        <LiveBadge text="Şu An Aktif" style={{ marginBottom: '1.25rem' }} />

        <h2 style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontWeight: 800,
          fontSize: 'clamp(1.6rem, 4vw, 2.75rem)',
          color: 'var(--text)',
          lineHeight: 1.1,
          letterSpacing: '-.035em',
          marginBottom: '.75rem',
        }}>
          {headline || 'Yolda Kalma.'}
          <br />
          <span style={{ color: 'var(--red)' }}>{sub || 'Hemen Ara.'}</span>
        </h2>

        <p style={{ fontSize: '.9rem', color: 'var(--text2)', marginBottom: '2rem', maxWidth: 420, margin: '0 auto 2rem' }}>
          Kocaeli genelinde ortalama <strong style={{ color: 'var(--text)' }}>30 dakikada</strong> yanınızdayız.
        </p>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '.75rem', justifyContent: 'center' }}>
          <a
            href={PHONES.main_tel}
            data-testid="final-cta-call"
            className="btn btn-primary btn-xl ring num"
            onClick={onCallClick()}
            style={{ gap: '.625rem' }}
          >
            <Phone size={17} /> Hemen Ara — {PHONES.main}
          </a>
          <a
            href={CONTACT.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-whatsapp"
            data-gtm-action="whatsapp_click"
            className="btn btn-green"
            onClick={onWhatsappClick()}
            style={{ gap: '.5rem', padding: '.875rem 1.5rem', borderRadius: 'var(--rl)', fontSize: '.9375rem', fontWeight: 700 }}
          >
            {WA_ICON} WhatsApp
          </a>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '.5rem', justifyContent: 'center', marginTop: '1.5rem' }}>
          {['Ort. 30 dk müdahale', '24 ay garanti', '12+ ilçe kapsama'].map(t => (
            <span key={t} style={{
              display: 'inline-flex', alignItems: 'center', gap: '.3rem',
              background: 'rgba(13,14,32,.6)', backdropFilter: 'blur(10px)',
              border: '1px solid var(--border)', borderRadius: 100,
              padding: '.25rem .75rem', fontSize: '.75rem', color: 'var(--text2)',
            }}>
              <span style={{ color: 'var(--green)', fontSize: '.65rem' }}>&#10003;</span> {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
